export default __webpack_public_path__ + "static/media/thumbnail.79a4f950.png";